import { round, withDefaultRoundingStrategy } from 'financial-number'
import type { FinancialNumber } from 'financial-number'
export type { FinancialNumber }

const fnum = withDefaultRoundingStrategy(round)

export default fnum

export type SomeTypeOfNumber = FinancialNumber | number | string

export const financial_sum = (numbers: SomeTypeOfNumber[]) => numbers.reduce((sum: FinancialNumber, addend) => sum.plus(addend.toString()), fnum(`0`))

export const financial_min = (...numbers: FinancialNumber[]) => numbers.reduce((min, x) => x.lt(min) ? x : min)

export const financial_max = (...numbers: FinancialNumber[]) => numbers.reduce((max, x) => x.gt(max) ? x : max)

export const zero = fnum(`0`)

export const fnum_to_num = (x: FinancialNumber | number): number => parseFloat(x.toString())

export const trim_excessive_precision = (n: SomeTypeOfNumber) => {
	const str = n.toString()
	return str.includes(`.`) ? str.replace(/\.?0+$/, ``) : str
}
